import Moment from "moment";

export const assignAddons = (age, zone) => {
  let selectedvalue = [];
  let value;
  // const date = dob;
  
  // const getAge = Math.floor(
  //   (new Date() - new Date(date).getTime()) / 3.15576e10
  // );
  const getAge = age;
  //console.log(getAge,"getAge")
  if (getAge <= 35) {
    selectedvalue.push(
      { value: "CARESHILED1104", label: "Care Shield" },
      { value: "CAREWITHNCB", label: "NCB-Super" }
    );
    let recVal = Array.isArray(selectedvalue)
      ? selectedvalue.map((e) => e.value)
      : [];
    value = recVal.join();
    // setFieldValue(name,recVal.join())
  } else if (getAge <= 45 && getAge > 35) {
    selectedvalue.push({ value: "CAREWITHNCB", label: "NCB-Super" });
    let recVal = Array.isArray(selectedvalue)
      ? selectedvalue.map((e) => e.value)
      : [];
    value = recVal.join();
  } else if (getAge > 45 && zone === "Zone 3") {
    selectedvalue.push({ value: "OPDCARE-5000", label: "OPD Care (Opd care is available only for 5000)" });
    let recVal = Array.isArray(selectedvalue)
      ? selectedvalue.map((e) => e.value)
      : [];
    value = recVal.join();
    console.log("OPD-5k is set")
  } else {
    value = "";
  }
  return value;
};

export const reInitialiseTabCareIntitialValues = (
  initialValues,
  quickValues
) => {
  //console.log('reinitialize', initialValues, refValues)

  let baseAgentId =
    window.location.hostname.trim() === "acuvisor.com"
      ? "20548096"
      : "20008325";
  Object.entries(initialValues).map((tab, tabInd) => {
    if (Array.isArray(tab[1])) {
      switch (tab[0]) {
        case "primaryDetail":
          tab[1].map((primaryObj, ind) => {
            initialValues["primaryDetail"][`${ind}`] = {
              ...initialValues["primaryDetail"][`${ind}`],
              ["roleCd"]: "PRIMARY",
              // ['abacusId']: quickValues['abacusId'],
              // ['term']: quickValues.period,
              // ['coverType']: quickValues.coverType,
              // ['quotationPremium']: quickValues.premium,
              // ['quotationReferenceNum']: quickValues.abacusId,
              // ['isPremiumCalculation']: "YES",
              // ['eldestMemberAge']: quickValues.eldestMemberAge,
              // ['baseAgentId']: baseAgentId,
              // ['baseProductId']: "10001102",
              // ['sumInsured']: quickValues.sumInsured,
              // ['sumInsuredValue']: quickValues.sumInsuredValue
            };
            //console.log('pri', primaryObj)

            primaryObj.partyAddressDOList[0] = {
              ...primaryObj.partyAddressDOList[0],
              addressTypeCd: "PERMANENT",
              addressTypeCd2: "COMMUNICATION",
              countryCd: "IND",
              countryCd2: "IND",
            };
            primaryObj.partyContactDOList[0] = {
              ...primaryObj.partyContactDOList[0],
              stdCode: "+91",
            };

            primaryObj.partyAddressDOList[0] = {
              ...primaryObj.partyAddressDOList[0],
              addressTypeCd: "PERMANENT",
              addressTypeCd2: "COMMUNICATION",
            };
          });

          let relation = "";

          tab[1].map((primaryObj, ind) => {
            quickValues.insureds.map((insure, insureIndex) => {
              //localStorage.clear();

              //localStorage.setItem(`date[${insureIndex}]`,`${insure.dob}`)

              relation = insure.Relationship === "1" ? "SELF" : "";
              /* initialValues['primaryDetail'][`${insureIndex}`] = {
                                ...initialValues['primaryDetail'][`${insureIndex}`],
                                ['birthDt']: insure.dob,
                                ['firstName']: insure.name,
                                ['relationCd']: relation


                            } */
              if (parseInt(quickValues.premium) >= 50) {
                //console.log('iisn',primaryObj.partyIdentityDOList)
                initialValues["primaryDetail"][
                  `${insureIndex}`
                ].partyIdentityDOList[0] = {
                  ...initialValues["primaryDetail"][`${insureIndex}`]
                    .partyIdentityDOList[0],
                  identityTypeCd: "PAN",
                };
              }
            });
          });

          break;
        case "dependentDetail":
          tab[1].map((primaryObj, ind) => {
            //console.log('pri', primaryObj)
            primaryObj.partyAddressDOList[0] = {
              ...primaryObj.partyAddressDOList[0],
              countryCd: "IND",
              countryCd2: "IND",
            };
            primaryObj.partyContactDOList[0] = {
              ...primaryObj.partyContactDOList[0],
              stdCode: "+91",
            };
          });
          tab[1].map((primaryObj, ind) => {
            initialValues["dependentDetail"][`${ind}`] = {
              ...initialValues["dependentDetail"][`${ind}`],
              ["roleCd"]: "PROPOSER",
            };
          });
          tab[1].map((primaryObj, ind) => {
            //console.log('hsh', primaryObj)
            quickValues.insureds.map((insure) => {
              initialValues["dependentDetail"][`${ind}`] = {
                ...initialValues["dependentDetail"][`${ind}`],
                /*  ['birthDt']: insure.dob,
                                 ['firstName']: insure.name,
                                 ['Relationship']: insure.relationCd, */
                relationCd: "SELF",
              };
            });
          });

          break;
        case "nomineeDetail":
          break;
      }
    } else {
      switch (tab[0]) {
        case "dependentDetail":
          let primaryObj = tab[1];

          // if(parseInt(quickValues.premium) >= 50){
          //     //console.log('iisn',primaryObj.partyIdentityDOList)
          //     primaryObj.partyIdentityDOList[0]={
          //         ...primaryObj.partyIdentityDOList[0],
          //         'identityTypeCd':"PAN"
          //     }
          // }

          if (parseInt(quickValues.premium) >= 50) {
            console.log("prem", quickValues.premium);
            primaryObj.partyIdentityDOList[0] = {
              ...primaryObj.partyIdentityDOList[0],
              identityTypeCd: "PAN",
            };
          }

          primaryObj.partyAddressDOList[0] = {
            ...primaryObj.partyAddressDOList[0],
            addressTypeCd: "PERMANENT",
            addressTypeCd2: "COMMUNICATION",
            countryCd: "IND",
            countryCd2: "IND",
          };
          primaryObj.partyContactDOList[0] = {
            ...primaryObj.partyContactDOList[0],
            stdCode: "+91",
          };
          primaryObj.policyAdditionalFieldsDOList = {
            ...primaryObj.policyAdditionalFieldsDOList,
            ["field1"]: "Partner_Acuvisor",
          };

          if (
            quickValues.ckycDetails !== undefined &&
            quickValues.ckycDetails !== ""
          ) {
            /* let arrayIdentity=[]
                         let arrayAddress =[]
                         let arrayContact =[]
                         let arrayEmail=[]
                         let identity = initialValues['dependentDetail']['partyIdentityDOList'][0]
                         let address = initialValues['dependentDetail']['partyAddressDOList'][0]
                         let contact = initialValues['dependentDetail']['partyContactDOList'][0]
                         let email = initialValues['dependentDetail']['partyEmailDOList'][0]*/
            let ckyc = "YES";
            /*  identity={
                              ...identity,
                              ['identityTypeCd']:"PAN",
                              ['panNumber']: quickValues.ckycDetails.pan
                          }  
                          address={
                              ...address,
                              ['addressLine1Lang1']:quickValues.ckycDetails.permLine1,
                              ['addressLine2Lang1']:quickValues.ckycDetails.permLine2,
                              ['pinCode']:quickValues.ckycDetails.permPin,
                              ['cityCd']:quickValues.ckycDetails.permCity,
                              ['areaCd']:quickValues.ckycDetails.permDist,
                              ['stateCd']:quickValues.ckycDetails.permState,
                          }
                          contact={
                              ...contact,
                              ['contactTypeCd']:"MOBILE",
                              ['contactNum']:quickValues.ckycDetails.mobNum,
                              ['stdCode']:quickValues.ckycDetails.mobCode,
      
                          }
                          email={
                              ...email,
                              ['emailTypeCd']:"PERSONAL",
                              ['emailAddress']:quickValues.ckycDetails.email,
      
                          }
  
                          arrayIdentity.push(identity)
                          arrayAddress.push(address)
                          arrayContact.push(contact)
                          arrayEmail.push(email)
  */
            initialValues["dependentDetail"] = {
              ...initialValues["dependentDetail"],
              ["roleCd"]: "PROPOSER",
              ["relationCd"]: "SELF",
              ["abacusId"]: quickValues["abacusId"],
              ["term"]: quickValues.period,
              ["coverType"]: quickValues.coverType,
              ["quotationPremium"]: quickValues.premium,
              ["quotationReferenceNum"]: quickValues.abacusId,
              ["isPremiumCalculation"]: "YES",
              ["eldestMemberAge"]: quickValues.eldestMemberAge,
              ["baseAgentId"]: baseAgentId,
              ["baseProductId"]: "10001102",
              ["sumInsured"]: quickValues.sumInsured,
              ["sumInsuredValue"]: quickValues.sumInsuredValue,
              ["addOns"]: assignAddons(quickValues.eldestMemberAge,quickValues?.pincodeZone),
              //['birthDt']: moment(quickValues.ckycDetails.dob, "DD/MM/YYYY"),
              //['firstName']: quickValues.ckycDetails.firstName,
              //['lastName']: quickValues.ckycDetails.lastName,
              //['genderCd']: quickValues.ckycDetails.gender,
              //['titleCd']: quickValues.ckycDetails.prefix,
              //['partyIdentityDOList']:arrayIdentity,
              //['partyAddressDOList']:arrayAddress,
              //['partyContactDOList']:arrayContact,
              //['partyEmailDOList']:arrayEmail,
              ["ckyc"]: ckyc,
              ["ckycNumber"]: quickValues.ckycDetails.ckycNo,
            };
          } else if (
            quickValues.ekycDetails !== undefined &&
            quickValues.ekycDetails !== ""
          ) {
            /*  let arrayIdentity=[]
                          let arrayAddress =[]
                          let arrayContact =[]
                          let arrayEmail=[]
                          let identity = initialValues['dependentDetail']['partyIdentityDOList'][0]
                          let address = initialValues['dependentDetail']['partyAddressDOList'][0]
                          let contact = initialValues['dependentDetail']['partyContactDOList'][0]
                          let email = initialValues['dependentDetail']['partyEmailDOList'][0] */
            let ekyc = "YES";
            /*identity={
                            ...identity,
                            ['identityTypeCd']:"PAN",
                            ['panNumber']: quickValues.ekycDetails.pan
                        }  
                        address={
                            ...address,
                            ['addressLine1Lang1']:quickValues.ekycDetails.permLine1,
                            ['addressLine2Lang1']:quickValues.ekycDetails.permLine2,
                            ['pinCode']:quickValues.ekycDetails.permPin,
                            ['cityCd']:quickValues.ekycDetails.permCity,
                            ['areaCd']:quickValues.ekycDetails.permDist,
                            ['stateCd']:quickValues.ekycDetails.permState,
                        }
                        contact={
                            ...contact,
                            ['contactTypeCd']:"MOBILE",
                            ['contactNum']:quickValues.ekycDetails.mobNum,
                            ['stdCode']:quickValues.ekycDetails.mobCode,
    
                        }
                        email={
                            ...email,
                            ['emailTypeCd']:"PERSONAL",
                            ['emailAddress']:quickValues.ekycDetails.email,
    
                        }
 
                        arrayIdentity.push(identity)
                        arrayAddress.push(address)
                        arrayContact.push(contact)
                        arrayEmail.push(email)
*/
            initialValues["dependentDetail"] = {
              ...initialValues["dependentDetail"],
              ["roleCd"]: "PROPOSER",
              ["relationCd"]: "SELF",
              ["abacusId"]: quickValues["abacusId"],
              ["term"]: quickValues.period,
              ["coverType"]: quickValues.coverType,
              ["quotationPremium"]: quickValues.premium,
              ["quotationReferenceNum"]: quickValues.abacusId,
              ["isPremiumCalculation"]: "YES",
              ["eldestMemberAge"]: quickValues.eldestMemberAge,
              ["baseAgentId"]: baseAgentId,
              ["baseProductId"]: "10001102",
              ["sumInsured"]: quickValues.sumInsured,
              ["sumInsuredValue"]: quickValues.sumInsuredValue,
              ["addOns"]: assignAddons(quickValues.eldestMemberAge,quickValues.pincodeZone),
              //['birthDt']: moment(quickValues.ekycDetails.dob, "DD/MM/YYYY"),
              //['firstName']: quickValues.ekycDetails.firstName,
              //['lastName']: quickValues.ekycDetails.lastName,
              //['genderCd']: quickValues.ekycDetails.gender,
              //['titleCd']: quickValues.ekycDetails.prefix,
              //['partyIdentityDOList']:arrayIdentity,
              //['partyAddressDOList']:arrayAddress,
              //['partyContactDOList']:arrayContact,
              //['partyEmailDOList']:arrayEmail,
              ["ekyc"]: "YES",
              ["ekycRefNo"]: quickValues.ekycDetails.requestId,
            };
          } else {
            initialValues["dependentDetail"] = {
              ...initialValues["dependentDetail"],
              ["roleCd"]: "PROPOSER",
              ["relationCd"]: "SELF",
              ["abacusId"]: quickValues["abacusId"],
              ["term"]: quickValues.period,
              ["coverType"]: quickValues.coverType,
              ["quotationPremium"]: quickValues.premium,
              ["quotationReferenceNum"]: quickValues.abacusId,
              ["isPremiumCalculation"]: "YES",
              ["eldestMemberAge"]: quickValues.eldestMemberAge,
              ["baseAgentId"]: baseAgentId,
              ["baseProductId"]: "10001102",
              ["sumInsured"]: quickValues.sumInsured,
              ["sumInsuredValue"]: quickValues.sumInsuredValue,
              ["addOns"]: assignAddons(quickValues.eldestMemberAge,quickValues.pincodeZone),
              ["ovdkyc"]: "YES",
            };
          }

          break;
      }
    }
    // console.log('reini', initialValues)
  });
  return initialValues;
};

export const reInitialiseTabCareSeniorIntitialValues = (
  initialValues,
  quickValues
) => {
  //console.log('reinitialize', initialValues, refValues)
  let baseAgentId =
    window.location.hostname.trim() === "acuvisor.com"
      ? "20548096"
      : "20008325";

  Object.entries(initialValues).map((tab, tabInd) => {
    if (Array.isArray(tab[1])) {
      switch (tab[0]) {
        case "primaryDetail":
          tab[1].map((primaryObj, ind) => {
            initialValues["primaryDetail"][`${ind}`] = {
              ...initialValues["primaryDetail"][`${ind}`],
              ["roleCd"]: "PRIMARY",

              /*       ['abacusId']: quickValues['abacusId'],
                                  ['term']: quickValues.period,
                                  ['coverType']: quickValues.coverType,
                                  ['quotationPremium']: quickValues.premium,
                                  ['quotationReferenceNum']: quickValues.abacusId,
                                  ['isPremiumCalculation']: "YES",
                                  ['eldestMemberAge']: quickValues.eldestMemberAge,
                                  ['baseAgentId']: baseAgentId,
                                  ['baseProductId']: "10001101",
                                  ['sumInsured']: quickValues.sumInsured,
                                  ['sumInsuredValue']: quickValues.sumInsuredValue */
            };
            //console.log('pri', primaryObj)
            primaryObj.partyAddressDOList[0] = {
              ...primaryObj.partyAddressDOList[0],
              addressTypeCd: "PERMANENT",
              addressTypeCd2: "COMMUNICATION",
              countryCd: "IND",
              countryCd2: "IND",
            };
            primaryObj.partyContactDOList[0] = {
              ...primaryObj.partyContactDOList[0],
              stdCode: "+91",
            };
          });

          tab[1].map((primaryObj, ind) => {
            quickValues.insureds.map((insure, insureIndex) => {
              initialValues["primaryDetail"][`${insureIndex}`] = {
                ...initialValues["primaryDetail"][`${insureIndex}`],
                ["birthDt"]: insure.dob,
                ["firstName"]: insure.name,

                //['Relationship']: insure.relationCd,
              };
            });
          });

          let relation = "";

          tab[1].map((primaryObj, ind) => {
            quickValues.insureds.map((insure, insureIndex) => {
              //localStorage.setItem(`date[${insureIndex}]`,`${insure.dob}`)

              relation = insure.Relationship === "1" ? "SELF" : "";
              initialValues["primaryDetail"][`${insureIndex}`] = {
                ...initialValues["primaryDetail"][`${insureIndex}`],
                ["birthDt"]: insure.dob,
                ["firstName"]: insure.name,
                ["relationCd"]: relation,
              };
              if (parseInt(quickValues.premium) >= 50) {
                //console.log('iisn',primaryObj.partyIdentityDOList)
                initialValues["primaryDetail"][
                  `${insureIndex}`
                ].partyIdentityDOList[0] = {
                  ...initialValues["primaryDetail"][`${insureIndex}`]
                    .partyIdentityDOList[0],
                  identityTypeCd: "PAN",
                };
              }
            });
          });

          break;
        case "dependentDetail":
          tab[1].map((primaryObj, ind) => {
            //console.log('pri', primaryObj)
            primaryObj.partyAddressDOList[0] = {
              ...primaryObj.partyAddressDOList[0],
              countryCd: "IND",
              countryCd2: "IND",
            };
            primaryObj.partyContactDOList[0] = {
              ...primaryObj.partyContactDOList[0],
              stdCode: "+91",
            };
          });
          tab[1].map((primaryObj, ind) => {
            initialValues["dependentDetail"][`${ind}`] = {
              ...initialValues["dependentDetail"][`${ind}`],
              ["roleCd"]: "PROPOSER",
            };
          });
          tab[1].map((primaryObj, ind) => {
            //console.log('hsh', primaryObj)
            quickValues.insureds.map((insure) => {
              initialValues["dependentDetail"][`${ind}`] = {
                ...initialValues["dependentDetail"][`${ind}`],
                /*  ['birthDt']: insure.dob,
                                 ['firstName']: insure.name,
                                 ['Relationship']: insure.relationCd, */
                relationCd: "SELF",
              };
            });
          });
          /*   tab[1].map((primaryObj, ind) => {
                          console.log('hsh', primaryObj)
                          quickValues.insureds.map(insure => {
                              initialValues['dependentDetail'][`${ind}`] = {
                                  ...initialValues['dependentDetail'][`${ind}`],
                                  ['birthDt']: insure.dob,
                                  ['firstName']: insure.name,
                                  ['Relationship']: insure.relationCd,
  
                              }
                          })
                      })
   */
          break;
        case "nomineeDetail":
          break;
      }
    } else {
      switch (tab[0]) {
        case "dependentDetail":
          let primaryObj = tab[1];
          //console.log('pri',primaryObj,quickValues.premium)
          // if(parseInt(quickValues.premium) >= 50){
          //     //console.log('iisn',primaryObj.partyIdentityDOList)
          //     primaryObj.partyIdentityDOList[0]={
          //         ...primaryObj.partyIdentityDOList[0],
          //         'identityTypeCd':"PAN"
          //     }
          // }

          if (parseInt(quickValues.premium) >= 50) {
            console.log("prem", quickValues.premium);
            primaryObj.partyIdentityDOList[0] = {
              ...primaryObj.partyIdentityDOList[0],
              identityTypeCd: "PAN",
            };
          }
          primaryObj.policyAdditionalFieldsDOList = {
            ...primaryObj.policyAdditionalFieldsDOList,
            ["field1"]: "Partner_Acuvisor",
          };
          primaryObj.partyAddressDOList[0] = {
            ...primaryObj.partyAddressDOList[0],
            addressTypeCd: "PERMANENT",
            addressTypeCd2: "COMMUNICATION",
            countryCd: "IND",
            countryCd2: "IND",
          };
          primaryObj.partyContactDOList[0] = {
            ...primaryObj.partyContactDOList[0],
            stdCode: "+91",
          };

          if (
            quickValues.ckycDetails !== undefined &&
            quickValues.ckycDetails !== ""
          ) {
            let ckyc = "YES";
            initialValues["dependentDetail"] = {
              ...initialValues["dependentDetail"],
              ["roleCd"]: "PROPOSER",
              ["relationCd"]: "SELF",
              ["abacusId"]: quickValues["abacusId"],
              ["term"]: quickValues.period,
              ["coverType"]: quickValues.coverType,
              ["quotationPremium"]: quickValues.premium,
              ["quotationReferenceNum"]: quickValues.abacusId,
              ["isPremiumCalculation"]: "YES",
              ["eldestMemberAge"]: quickValues.eldestMemberAge,
              ["baseAgentId"]: baseAgentId,
              ["baseProductId"]: "10001102",
              ["sumInsured"]: quickValues.sumInsured,
              ["sumInsuredValue"]: quickValues.sumInsuredValue,
              ["addOns"]: assignAddons(quickValues?.eldestMemberAge,quickValues?.pincodeZone),
              ["ckyc"]: ckyc,
              ["ckycNumber"]: quickValues.ckycDetails.ckycNo,
            };
          } else if (
            quickValues.ekycDetails !== undefined &&
            quickValues.ekycDetails !== ""
          ) {
            initialValues["dependentDetail"] = {
              ...initialValues["dependentDetail"],
              ["roleCd"]: "PROPOSER",
              ["relationCd"]: "SELF",
              ["abacusId"]: quickValues["abacusId"],
              ["term"]: quickValues.period,
              ["coverType"]: quickValues.coverType,
              ["quotationPremium"]: quickValues.premium,
              ["quotationReferenceNum"]: quickValues.abacusId,
              ["isPremiumCalculation"]: "YES",
              ["eldestMemberAge"]: quickValues.eldestMemberAge,
              ["baseAgentId"]: baseAgentId,
              ["baseProductId"]: "10001102",
              ["sumInsured"]: quickValues.sumInsured,
              ["sumInsuredValue"]: quickValues.sumInsuredValue,
              ["addOns"]: assignAddons(quickValues?.eldestMemberAge,quickValues?.pincodeZone),
              ["ekyc"]: "YES",
              ["ekycRefNo"]: quickValues.ekycDetails.requestId,
            };
          } else {
            initialValues["dependentDetail"] = {
              ...initialValues["dependentDetail"],
              ["roleCd"]: "PROPOSER",
              ["relationCd"]: "SELF",
              ["abacusId"]: quickValues["abacusId"],
              ["term"]: quickValues.period,
              ["coverType"]: quickValues.coverType,
              ["quotationPremium"]: quickValues.premium,
              ["quotationReferenceNum"]: quickValues.abacusId,
              ["isPremiumCalculation"]: "YES",
              ["eldestMemberAge"]: quickValues.eldestMemberAge,
              ["baseAgentId"]: baseAgentId,
              ["baseProductId"]: "10001102",
              ["sumInsured"]: quickValues.sumInsured,
              ["sumInsuredValue"]: quickValues.sumInsuredValue,
              ["addOns"]: assignAddons(quickValues?.eldestMemberAge,quickValues?.pincodeZone),
              ["ovdkyc"]: "YES",
            };
          }

          /*   tab[1].map((primaryObj, ind) => {
                          console.log('hsh', primaryObj)
                          quickValues.insureds.map(insure => {
                              initialValues['dependentDetail'][`${ind}`] = {
                                  ...initialValues['dependentDetail'][`${ind}`],
                                  ['birthDt']: insure.dob,
                                  ['firstName']: insure.name,
                                  ['Relationship']: insure.relationCd,
  
                              }
                          })
                      })
   */
          break;
      }
    }
  });
  //console.log('reini', initialValues)
  return initialValues;
};

export const reInitialiseTabCareFreedomIntitialValues = (
  initialValues,
  quickValues
) => {
  //console.log('reinitialize', initialValues, refValues)
  let baseAgentId =
    window.location.hostname.trim() === "acuvisor.com"
      ? "20548096"
      : "20008325";

  Object.entries(initialValues).map((tab, tabInd) => {
    if (Array.isArray(tab[1])) {
      switch (tab[0]) {
        case "primaryDetail":
          tab[1].map((primaryObj, ind) => {
            initialValues["primaryDetail"][`${ind}`] = {
              ...initialValues["primaryDetail"][`${ind}`],
              //['term']: quickValues.period,
              ["roleCd"]: "PRIMARY",
              // ['coverType']: quickValues.coverType,
              // ['quotationReferenceNum']: quickValues.abacusId,
              // ['isPremiumCalculation']: "YES",
              // ['baseAgentId']: baseAgentId,
              // ['baseProductId']: "12001009",
              // ['sumInsured']: quickValues.sumInsuredValue,
            };
            //console.log('pri', primaryObj)
            primaryObj.partyAddressDOList[0] = {
              ...primaryObj.partyAddressDOList[0],
              addressTypeCd: "PERMANENT",
              addressTypeCd2: "COMMUNICATION",
              countryCd: "IND",
              countryCd2: "IND",
            };
            primaryObj.partyContactDOList[0] = {
              ...primaryObj.partyContactDOList[0],
              stdCode: "+91",
            };
          });
          /*  tab[1].map((primaryObj, ind) => {
                         quickValues.insureds.map((insure, insureIndex) => {
                             //localStorage.setItem(`date[${insureIndex}]`,`${insure.dob}`)
 
                             initialValues['primaryDetail'][`${insureIndex}`] = {
                                 ...initialValues['primaryDetail'][`${insureIndex}`],
                                 ['birthDt']: insure.dob,
                                 ['firstName']: insure.name,
 
                                 //['Relationship']: insure.relationCd,
 
                             }
                         })
                     }) */

          let relation = "";

          tab[1].map((primaryObj, ind) => {
            quickValues.insureds.map((insure, insureIndex) => {
              relation = insure.Relationship === "1" ? "SELF" : "";
              console.log("selefs", insure.Relationship);

              /*  if (Number(insure.Relationship) === 1 && quickValues.ckycDetails !==undefined && quickValues.ckycDetails !== "") {
                                  console.log('KYC', quickValues.ckycDetails)
                                  //console.log('selefs',insure.Relationship)
                                  let arrayIdentity=[]
                                  let arrayAddress =[]
                                  let arrayContact =[]
                                  let arrayEmail=[]
                                  let identity = initialValues['primaryDetail'][`${insureIndex}`]['partyIdentityDOList'][0]
                                  let address = initialValues['primaryDetail'][`${insureIndex}`]['partyAddressDOList'][0]
                                  let contact = initialValues['primaryDetail'][`${insureIndex}`]['partyContactDOList'][0]
                                  let email = initialValues['primaryDetail'][`${insureIndex}`]['partyEmailDOList'][0]
  
                                  identity={
                                      ...identity,
                                      ['identityTypeCd']:"PAN",
                                      ['panNumber']: quickValues.ckycDetails.pan
                                  }  
                                  address={
                                      ...address,
                                      ['addressLine1Lang1']:quickValues.ckycDetails.permLine1,
                                      ['addressLine2Lang1']:quickValues.ckycDetails.permLine2,
                                      ['pinCode']:quickValues.ckycDetails.permPin,
                                      ['cityCd']:quickValues.ckycDetails.permCity,
                                      ['areaCd']:quickValues.ckycDetails.permDist,
                                      ['stateCd']:quickValues.ckycDetails.permState,
                                  }
                                  contact={
                                      ...contact,
                                      ['contactTypeCd']:"MOBILE",
                                      ['contactNum']:quickValues.ckycDetails.mobNum,
                                      ['stdCode']:quickValues.ckycDetails.mobCode,
  
                                  }
                                  email={
                                      ...email,
                                      ['emailTypeCd']:"PERSONAL",
                                      ['emailAddress']:quickValues.ckycDetails.email,
  
                                  }
  
  
                                  arrayIdentity.push(identity)
                                  arrayAddress.push(address)
                                  arrayContact.push(contact)
                                  arrayEmail.push(email)
                                  //console.log('id', identity)
                                  initialValues['primaryDetail'][`${insureIndex}`] = {
                                      ...initialValues['primaryDetail'][`${insureIndex}`],
                                      ['birthDt']: moment(quickValues.ckycDetails.dob, "DD/MM/YYYY"),
                                      ['firstName']: quickValues.ckycDetails.firstName,
                                      ['lastName']: quickValues.ckycDetails.lastName,
                                      ['genderCd']: quickValues.ckycDetails.gender,
                                      ['relationCd']: relation,
                                      ['titleCd']: quickValues.ckycDetails.prefix,
                                      ['partyIdentityDOList']:arrayIdentity,
                                      ['partyAddressDOList']:arrayAddress,
                                      ['partyContactDOList']:arrayContact,
                                      ['partyEmailDOList']:arrayEmail,
  
                                  }
  
  
                              }else if (Number(insure.Relationship) === 1 && quickValues.ekycDetails !==undefined && quickValues.ekycDetails !== "") {
                                  console.log('KYC', quickValues.ekycDetails)
                                  //console.log('selefs',insure.Relationship)
                                  let arrayIdentity=[]
                                  let arrayAddress =[]
                                  let arrayContact =[]
                                  let arrayEmail=[]
                                  let identity = initialValues['primaryDetail'][`${insureIndex}`]['partyIdentityDOList'][0]
                                  let address = initialValues['primaryDetail'][`${insureIndex}`]['partyAddressDOList'][0]
                                  let contact = initialValues['primaryDetail'][`${insureIndex}`]['partyContactDOList'][0]
                                  let email = initialValues['primaryDetail'][`${insureIndex}`]['partyEmailDOList'][0]
  
                                  identity={
                                      ...identity,
                                      ['identityTypeCd']:"PAN",
                                      ['panNumber']: quickValues.ekycDetails.pan
                                  }  
                                  address={
                                      ...address,
                                      ['addressLine1Lang1']:quickValues.ekycDetails.permLine1,
                                      ['addressLine2Lang1']:quickValues.ekycDetails.permLine2,
                                      ['pinCode']:quickValues.ekycDetails.permPin,
                                      ['cityCd']:quickValues.ekycDetails.permCity,
                                      ['areaCd']:quickValues.ekycDetails.permDist,
                                      ['stateCd']:quickValues.ekycDetails.permState,
                                  }
                                  contact={
                                      ...contact,
                                      ['contactTypeCd']:"MOBILE",
                                      ['contactNum']:quickValues.ekycDetails.mobNum,
                                      ['stdCode']:quickValues.ekycDetails.mobCode,
  
                                  }
                                  email={
                                      ...email,
                                      ['emailTypeCd']:"PERSONAL",
                                      ['emailAddress']:quickValues.ekycDetails.email,
  
                                  }
  
  
                                  arrayIdentity.push(identity)
                                  arrayAddress.push(address)
                                  arrayContact.push(contact)
                                  arrayEmail.push(email)
                                  //console.log('id', identity)
                                  initialValues['primaryDetail'][`${insureIndex}`] = {
                                      ...initialValues['primaryDetail'][`${insureIndex}`],
                                      ['birthDt']: moment(quickValues.ekycDetails.dob, "DD/MM/YYYY"),
                                      ['firstName']: quickValues.ekycDetails.firstName,
                                      ['lastName']: quickValues.ekycDetails.lastName,
                                      ['genderCd']: quickValues.ekycDetails.gender,
                                      ['relationCd']: relation,
                                      ['titleCd']: quickValues.ekycDetails.prefix,
                                      ['partyIdentityDOList']:arrayIdentity,
                                      ['partyAddressDOList']:arrayAddress,
                                      ['partyContactDOList']:arrayContact,
                                      ['partyEmailDOList']:arrayEmail,
  
                                  }
  
  
                              } else {
                                  initialValues['primaryDetail'][`${insureIndex}`] = {
                                      ...initialValues['primaryDetail'][`${insureIndex}`],
                                      ['birthDt']: insure.dob,
                                      ['firstName']: insure.name,
                                      ['relationCd']: relation
  
  
                                  }
                              } */

              if (parseInt(quickValues.premium) >= 50) {
                //console.log('iisn',primaryObj.partyIdentityDOList)primaryDetail[0].partyIdentityDOList[0].identityTypeCd
                //console.log('kkk', document.getElementById(`primaryDetail[${ind}].partyIdentityDOList[0].identityTypeCd`))

                initialValues["primaryDetail"][
                  `${insureIndex}`
                ].partyIdentityDOList[0] = {
                  ...initialValues["primaryDetail"][`${insureIndex}`]
                    .partyIdentityDOList[0],
                  identityTypeCd: "PAN",
                };
              }
            });
          });

          break;
        case "dependentDetail":
          tab[1].map((primaryObj, ind) => {
            //console.log('pri', primaryObj)
            primaryObj.partyAddressDOList[0] = {
              ...primaryObj.partyAddressDOList[0],
              countryCd: "IND",
              countryCd2: "IND",
            };
            primaryObj.partyContactDOList[0] = {
              ...primaryObj.partyContactDOList[0],
              stdCode: "+91",
            };
          });
          tab[1].map((primaryObj, ind) => {
            initialValues["dependentDetail"][`${ind}`] = {
              ...initialValues["dependentDetail"][`${ind}`],
              ["roleCd"]: "PROPOSER",
            };
          });
          tab[1].map((primaryObj, ind) => {
            //console.log('hsh', primaryObj)
            quickValues.insureds.map((insure) => {
              initialValues["dependentDetail"][`${ind}`] = {
                ...initialValues["dependentDetail"][`${ind}`],
                /* ['birthDt']: insure.dob,
                                ['firstName']: insure.name,
                                ['Relationship']: insure.relationCd, */
                relationCd: "SELF",
              };
            });
          });

          break;
        case "nomineeDetail":
          break;
      }
    } else {
      switch (tab[0]) {
        case "dependentDetail":
          let primaryObj = tab[1];

          // if(parseInt(quickValues.premium) >= 50){
          //     //console.log('iisn',primaryObj.partyIdentityDOList)
          //     primaryObj.partyIdentityDOList[0]={
          //         ...primaryObj.partyIdentityDOList[0],
          //         'identityTypeCd':"PAN"
          //     }
          // }

          if (parseInt(quickValues.premium) >= 50) {
            console.log("prem", quickValues.premium);
            primaryObj.partyIdentityDOList[0] = {
              ...primaryObj.partyIdentityDOList[0],
              identityTypeCd: "PAN",
            };
          }

          primaryObj.partyAddressDOList[0] = {
            ...primaryObj.partyAddressDOList[0],
            addressTypeCd: "PERMANENT",
            addressTypeCd2: "COMMUNICATION",
            countryCd: "IND",
            countryCd2: "IND",
          };
          primaryObj.partyContactDOList[0] = {
            ...primaryObj.partyContactDOList[0],
            stdCode: "+91",
          };

          primaryObj.policyAdditionalFieldsDOList = {
            ...primaryObj.policyAdditionalFieldsDOList,
            ["field1"]: "Partner_Acuvisor",
          };

          if (
            quickValues.ckycDetails !== undefined &&
            quickValues.ckycDetails !== ""
          ) {
            /* let arrayIdentity=[]
                         let arrayAddress =[]
                         let arrayContact =[]
                         let arrayEmail=[]
                         let identity = initialValues['dependentDetail']['partyIdentityDOList'][0]
                         let address = initialValues['dependentDetail']['partyAddressDOList'][0]
                         let contact = initialValues['dependentDetail']['partyContactDOList'][0]
                         let email = initialValues['dependentDetail']['partyEmailDOList'][0]*/
            let ckyc = "YES";
            /*  identity={
                              ...identity,
                              ['identityTypeCd']:"PAN",
                              ['panNumber']: quickValues.ckycDetails.pan
                          }  
                          address={
                              ...address,
                              ['addressLine1Lang1']:quickValues.ckycDetails.permLine1,
                              ['addressLine2Lang1']:quickValues.ckycDetails.permLine2,
                              ['pinCode']:quickValues.ckycDetails.permPin,
                              ['cityCd']:quickValues.ckycDetails.permCity,
                              ['areaCd']:quickValues.ckycDetails.permDist,
                              ['stateCd']:quickValues.ckycDetails.permState,
                          }
                          contact={
                              ...contact,
                              ['contactTypeCd']:"MOBILE",
                              ['contactNum']:quickValues.ckycDetails.mobNum,
                              ['stdCode']:quickValues.ckycDetails.mobCode,
      
                          }
                          email={
                              ...email,
                              ['emailTypeCd']:"PERSONAL",
                              ['emailAddress']:quickValues.ckycDetails.email,
      
                          }
  
                          arrayIdentity.push(identity)
                          arrayAddress.push(address)
                          arrayContact.push(contact)
                          arrayEmail.push(email)
  */
            initialValues["dependentDetail"] = {
              ...initialValues["dependentDetail"],
              ["roleCd"]: "PROPOSER",
              ["relationCd"]: "SELF",
              ["term"]: quickValues.period,
              ["coverType"]: quickValues.coverType,
              ["quotationReferenceNum"]: quickValues.abacusId,
              ["isPremiumCalculation"]: "YES",
              ["baseAgentId"]: baseAgentId,
              ["baseProductId"]: "12001009",
              ["sumInsured"]: quickValues.sumInsured,
              //['birthDt']: moment(quickValues.ckycDetails.dob, "DD/MM/YYYY"),
              //['firstName']: quickValues.ckycDetails.firstName,
              //['lastName']: quickValues.ckycDetails.lastName,
              //['genderCd']: quickValues.ckycDetails.gender,
              //['titleCd']: quickValues.ckycDetails.prefix,
              //['partyIdentityDOList']:arrayIdentity,
              //['partyAddressDOList']:arrayAddress,
              //['partyContactDOList']:arrayContact,
              //['partyEmailDOList']:arrayEmail,
              ["ckyc"]: ckyc,
              ["ckycNumber"]: quickValues.ckycDetails.ckycNo,
            };
          } else if (
            quickValues.ekycDetails !== undefined &&
            quickValues.ekycDetails !== ""
          ) {
            /*  let arrayIdentity=[]
                          let arrayAddress =[]
                          let arrayContact =[]
                          let arrayEmail=[]
                          let identity = initialValues['dependentDetail']['partyIdentityDOList'][0]
                          let address = initialValues['dependentDetail']['partyAddressDOList'][0]
                          let contact = initialValues['dependentDetail']['partyContactDOList'][0]
                          let email = initialValues['dependentDetail']['partyEmailDOList'][0] */
            let ekyc = "YES";
            /*identity={
                            ...identity,
                            ['identityTypeCd']:"PAN",
                            ['panNumber']: quickValues.ekycDetails.pan
                        }  
                        address={
                            ...address,
                            ['addressLine1Lang1']:quickValues.ekycDetails.permLine1,
                            ['addressLine2Lang1']:quickValues.ekycDetails.permLine2,
                            ['pinCode']:quickValues.ekycDetails.permPin,
                            ['cityCd']:quickValues.ekycDetails.permCity,
                            ['areaCd']:quickValues.ekycDetails.permDist,
                            ['stateCd']:quickValues.ekycDetails.permState,
                        }
                        contact={
                            ...contact,
                            ['contactTypeCd']:"MOBILE",
                            ['contactNum']:quickValues.ekycDetails.mobNum,
                            ['stdCode']:quickValues.ekycDetails.mobCode,
    
                        }
                        email={
                            ...email,
                            ['emailTypeCd']:"PERSONAL",
                            ['emailAddress']:quickValues.ekycDetails.email,
    
                        }

                        arrayIdentity.push(identity)
                        arrayAddress.push(address)
                        arrayContact.push(contact)
                        arrayEmail.push(email)
*/
                        initialValues['dependentDetail'] = {
                            ...initialValues['dependentDetail'],
                            ["roleCd"]: "PROPOSER",
                            ["relationCd"]: "SELF",
                            ['term']: quickValues.period,
                            ['coverType']: quickValues.coverType,
                            ['quotationReferenceNum']: quickValues.abacusId,
                            ['isPremiumCalculation']: "YES",
                            ['baseAgentId']: baseAgentId,
                            ['baseProductId']: "12001009",
                            ['sumInsured']: quickValues.sumInsured,
                            //['birthDt']: moment(quickValues.ekycDetails.dob, "DD/MM/YYYY"),
                            //['firstName']: quickValues.ekycDetails.firstName,
                            //['lastName']: quickValues.ekycDetails.lastName,
                            //['genderCd']: quickValues.ekycDetails.gender,
                            //['titleCd']: quickValues.ekycDetails.prefix,
                            //['partyIdentityDOList']:arrayIdentity,
                            //['partyAddressDOList']:arrayAddress,
                            //['partyContactDOList']:arrayContact,
                            //['partyEmailDOList']:arrayEmail,
                            ['ekyc']: "YES",
                            ['ekycRefNo']: quickValues.ekycDetails.requestId,
                        }

                    } else {
                        initialValues['dependentDetail'] = {
                            ...initialValues['dependentDetail'],
                            ["roleCd"]: "PROPOSER",
                            ["relationCd"]: "SELF",
                            ['term']: quickValues.period,
                            ['coverType']: quickValues.coverType,
                            ['quotationReferenceNum']: quickValues.abacusId,
                            ['isPremiumCalculation']: "YES",
                            ['baseAgentId']: baseAgentId,
                            ['baseProductId']: "12001009",
                            ['sumInsured']: quickValues.sumInsured,
                            ['ovdkyc']: "YES"
                        }
                    }



                    break;
            }
        }
    })
    //console.log('reini', initialValues)
    return initialValues
}

export const reInitialiseTabStarInitialValues = (initialValues, quickValues) => {
    //console.log('isni', initialValues.primaryDetail, quickValues)
    Object.entries(initialValues).map((tab, tabInd) => {
        if (Array.isArray(tab[1])) {
            switch (tab[0]) {
                case "primaryDetail":
                    tab[1].map((primaryObj, ind) => {
                        // console.log('hhh', primaryObj)
                        //console.log('ksdd', quickValues.insureds[ind].relationshipId)
                        if (quickValues.insureds[ind].relationshipId === '1') {
                            initialValues['primaryDetail'][`${ind}`] = {
                                ...initialValues['primaryDetail'][`${ind}`],
                                ['name']: quickValues?.proposerName ?? quickValues?.insureds[ind]?.name,
                                //['dob']: quickValues.insureds[ind].dob,
                                ['dob']: quickValues?.kycDetails.proposerDob,
                                ['sumInsuredId']: quickValues.sumInsuredId,
                                ['relationshipId']: quickValues.insureds[ind].relationshipId,
                                ['sex']: quickValues.gender
                                /*  ['code']: quickValues.code,
                                 ['codeType']: quickValues.codeType,
                                 ['period']: quickValues.period,
                                 ['postalCode']: quickValues.postalCode,
                                 ['schemeId']: quickValues.schemeId,
                                 ['sumInsuredId']: quickValues.sumInsuredId,
                                 ['proposerName']: quickValues.proposerName,
                                 ['proposerAreaId']: quickValues.proposerAreaId,
      */
              };
            } else {
              initialValues["primaryDetail"][`${ind}`] = {
                ...initialValues["primaryDetail"][`${ind}`],
                ["name"]: quickValues.insureds[ind].name,
                ["dob"]: quickValues.insureds[ind].dob,
                ["sumInsuredId"]: quickValues.sumInsuredId,
                ["relationshipId"]: quickValues.insureds[ind].relationshipId,
                /*  ['code']: quickValues.code,
                                 ['codeType']: quickValues.codeType,
                                 ['period']: quickValues.period,
                                 ['postalCode']: quickValues.postalCode,
                                 ['schemeId']: quickValues.schemeId,
                                 ['sumInsuredId']: quickValues.sumInsuredId,
                                 ['proposerName']: quickValues.proposerName,
                                 ['proposerAreaId']: quickValues.proposerAreaId,
      */
              };
            }
          });
          break;
        case "dependentDetail":
          initialValues["dependentDetail"] = {
            ...initialValues["dependentDetail"],
            /*  ['name']: quickValues.insureds[ind].name,
                         ['dob']: quickValues.insureds[ind].dob,
                         ['sumInsuredId']: quickValues.sumInsuredId,
                         ['relationshipId']: quickValues.insureds[ind].relationshipId, */
            //['code']: quickValues.code,

            ["codeType"]: quickValues.codeType,
            ["period"]: quickValues.period,
            ["postalCode"]: quickValues.postalCode,
            ["schemeId"]: quickValues.schemeId,
            ["sumInsuredId"]: quickValues.sumInsuredId,
            ["proposerName"]: quickValues.proposerName,
            ["proposerAreaId"]: quickValues.proposerAreaId,
            ["startOn"]: quickValues.startOn,
            ["endOn"]: quickValues.endOn,
            ["policyTypeName"]: quickValues.product_code,
          };
          break;
        case "nomineeDetail":
          break;
      }
    } else {
      switch (tab[0]) {
        case "dependentDetail":
          let ckycReferenceId = "";
          console.log("qq", quickValues.kycDetails);
          if (quickValues.kycDetails != undefined) {
            ckycReferenceId = quickValues.kycDetails.ckycReferenceId;
          }
          initialValues["dependentDetail"] = {
            ...initialValues["dependentDetail"],
            /*  ['name']: quickValues.insureds[ind].name,
                         ['dob']: quickValues.insureds[ind].dob,
                         ['sumInsuredId']: quickValues.sumInsuredId,
                         ['relationshipId']: quickValues.insureds[ind].relationshipId, */
                        //['code']: quickValues.code,
                        ['proposerDob']: quickValues.kycDetails.proposerDob,
                        ['codeType']: quickValues.codeType,
                        ['period']: quickValues.period,
                        ['postalCode']: quickValues.postalCode,
                        ['schemeId']: quickValues.schemeId,
                        ['sumInsuredId']: quickValues.sumInsuredId,
                        ['proposerName']: quickValues.proposerName,


                        ['proposerAreaId']: quickValues.proposerAreaId,
                        ['startOn']: quickValues.startOn,
                        ['endOn']: quickValues.endOn,
                        ['policyTypeName']: quickValues.product_code,
                        ['ckycReferenceId']:ckycReferenceId

                    }
                    break;
          //   //['code']: quickValues.code,
          //   ["codeType"]: quickValues.codeType,
          //   ["period"]: quickValues.period,
          //   ["postalCode"]: quickValues.postalCode,
          //   ["schemeId"]: quickValues.schemeId,
          //   ["sumInsuredId"]: quickValues.sumInsuredId,
          //   ["proposerName"]: quickValues.proposerName,

          //   ["proposerAreaId"]: quickValues.proposerAreaId,
          //   ["startOn"]: quickValues.startOn,
          //   ["endOn"]: quickValues.endOn,
          //   ["policyTypeName"]: quickValues.product_code,
          //   ["ckycReferenceId"]: ckycReferenceId,
          // };
          // break;
      }
    }
  });

  return initialValues;
};

export const reInitialiseTabHdfcInitialValues = (
  initialValues,
  quickValues
) => {
  //console.log('isni', initialValues.primaryDetail, quickValues)
  let insuredGender = "";
  let propGender = "";

  var currDate = Moment().format("YYYY-MM-DD");
  console.log("datem:",currDate)

  if (quickValues.gender === "Male") {
    propGender = "MALE";
    insuredGender = "MALE";
  } else if (quickValues.gender === "Female") {
    propGender = "FEMALE";
    insuredGender = "FEMALE";
  }
  Object.entries(initialValues).map((tab, tabInd) => {
    if (Array.isArray(tab[1])) {
      switch (tab[0]) {
        case "primaryDetail":
          tab[1].map((primaryObj, ind) => {
            if (
              quickValues.insureds[ind].relationship === "Wife" &&
              quickValues.gender === "Male"
            ) {
              initialValues["primaryDetail"][`${ind}`] = {
                ...initialValues["primaryDetail"][`${ind}`],
                ["PropRisks_NameofPerson"]: quickValues.insureds[ind].name,
                // ["PropRisks_DateOfBirth"]: quickValues.insureds[ind].dob,
                ["PropRisks_SumInsured"]: quickValues.sumInsuredValue,
                ["PropRisks_Relation"]: "Wife",
                ["PropRisks_Gender"]: "FEMALE",
                ["PropRisks_MaritalStatus"]:"Married",  
              };
            } else if (
              quickValues.insureds[ind].relationship === "Husband" &&
              quickValues.gender === "Female"
            ) {
              initialValues["primaryDetail"][`${ind}`] = {
                ...initialValues["primaryDetail"][`${ind}`],
                ["PropRisks_NameofPerson"]: quickValues.insureds[ind].name,
                // ["PropRisks_DateOfBirth"]: quickValues.insureds[ind].dob,
                ["PropRisks_SumInsured"]: quickValues.sumInsuredValue,
                ["PropRisks_Relation"]: "Husband",
                ["PropRisks_Gender"]: "MALE",
                ["PropRisks_MaritalStatus"]:"Married",
              };
            } else if (quickValues.insureds[ind].relationship === "Self") {
              initialValues["primaryDetail"][`${ind}`] = {
                ...initialValues["primaryDetail"][`${ind}`],
                ["PropRisks_NameofPerson"]: quickValues.insureds[ind].name,
                // ["PropRisks_DateOfBirth"]: quickValues.insureds[ind].dob,
                ["PropRisks_SumInsured"]: quickValues.sumInsuredValue,
                ["PropRisks_Relation"]: quickValues.insureds[ind].relationship,
                ["PropRisks_Gender"]: insuredGender,
              };
            } else {
              initialValues["primaryDetail"][`${ind}`] = {
                ...initialValues["primaryDetail"][`${ind}`],
                ["PropRisks_NameofPerson"]: quickValues.insureds[ind].name,
                // ["PropRisks_DateOfBirth"]: quickValues.insureds[ind].dob,
                ["PropRisks_SumInsured"]: quickValues.sumInsuredValue,
                ["PropRisks_Relation"]: quickValues.insureds[ind].relationship,
              };
            }
          });
          break;

        case "nomineeDetail":
          break;
      }
    } else {
      switch (tab[0]) {
        case "dependentDetail":
          initialValues["dependentDetail"] = {
            ...initialValues["dependentDetail"],
            ["Customer_FirstName"]: quickValues.kycDetails?.firstName ?? quickValues?.proposerName,
            ["Customer_MiddleName"]: quickValues?.kycDetails?.middleName,
            ["Customer_LastName"]: quickValues?.kycDetails?.lastName,
            ["Customer_Perm_Address1"]: quickValues?.kycDetails?.permanentAddress1,
            ["Customer_Perm_Address2"]: quickValues?.kycDetails?.permanentAddress2,
            ["Customer_DateofBirth"]: quickValues?.kycDetails?.dateOfBirth ?? "",
            ["Customer_Perm_PinCode"]:quickValues?.kycDetails?.permanentPincode ?? "",
            "Customer_Perm_CityDirstCode":quickValues?.kycDetails?.cityDistCd ?? "",
            "Customer_Perm_CityDistrict":quickValues?.kycDetails?.TXT_CITYDISTRICT ?? "",
            "Customer_Perm_StateCode":quickValues?.kycDetails?.stateCd ?? "",
            "Customer_PermState":quickValues?.kycDetails?.TXT_STATE ?? "",
            "Customer_Perm_PinCodeLocality":quickValues?.kycDetails?.pincodeLocality ?? "",
            ["POLICY_TENURE"]: quickValues.period,
            ["Customer_Gender"]: propGender,
            ["Customer_Pehchaan_id"]: quickValues.Customer_Pehchaan_id,
            ["PolicyStartDate"]: currDate,//quickValues.start_date,
            ["ProposalDate"]: currDate,//quickValues.proposal_date,
            ["PropRisks_Plan"]: quickValues.plan,
            ["PropRisks_Tier"]: quickValues.Prop_tier,
            ["Customer_Email"]: quickValues.email_id,
            ["Customer_Mobile"]: quickValues.mobile_no,
          };
          break;
      }
    }
  });

  return initialValues;
};

export const reInitialiseHdfcMedisureTopupInitialValues = (
  initialValues,
  quickValues
) => {
  console.log('isni', initialValues.primaryDetail, quickValues)
  let insuredGender = "";
  let propGender = "";

  var currDate = Moment().format("YYYY-MM-DD");
  console.log("datem:", currDate);

  if (quickValues.gender === "Male") {
    propGender = "MALE";
    insuredGender = "M";
  } else if (quickValues.gender === "Female") {
    propGender = "FEMALE";
    insuredGender = "F";
  }
  Object.entries(initialValues).forEach((tab, tabInd) => {
    if (Array.isArray(tab[1])) {
      switch (tab[0]) {
        case "primaryDetail":
          tab[1].forEach((primaryObj, ind) => {
            initialValues["primaryDetail"][`${ind}`] = {
              ...initialValues["primaryDetail"][`${ind}`],
              PropRisks_NameofPerson: quickValues.insureds[ind].name,
              PropRisks_DateOfBirth: quickValues?.insureds[ind]?.relationship === "Self"?quickValues?.kycDetails?.dateOfBirth:null,
              PropRisks_SumInsured_Mandatary: quickValues.sumInsuredValue,
              PropRisks_Relation: quickValues.insureds[ind].relationship,
              PropRisks_Gender: insuredGender,
              PropRisks_Deductable: quickValues.deductableValue
            };
          });
          break;

        case "nomineeDetail":
          break;
        default:
      }
    } else {
      switch (tab[0]) {
        case "dependentDetail":
          initialValues["dependentDetail"] = {
            ...initialValues["dependentDetail"],
            Customer_FirstName: quickValues?.kycDetails?.firstName,
            Customer_MiddleName:quickValues?.kycDetails.middleName,
            Customer_LastName:quickValues?.kycDetails?.lastName,
            Customer_DateofBirth:quickValues?.kycDetails?.dateOfBirth ?? "",
            Customer_Email:quickValues?.email_id,
            Customer_Mobile:quickValues?.mobile_no,
            POLICY_TERM: quickValues.period,
            Customer_Gender: propGender,
            Customer_Perm_Address1:quickValues?.kycDetails?.permanentAddress1,
            Customer_Perm_Address2:quickValues?.kycDetails?.permanentAddress2,
            Customer_Perm_PinCode:quickValues?.kycDetails?.permanentPincode,
            Customer_Perm_CityDistrict:quickValues?.kycDetails?.TXT_CITYDISTRICT,
            Customer_Perm_CityDirstCode:quickValues?.kycDetails?.cityDistCd,
            Customer_Perm_PinCodeLocality: quickValues?.kycDetails?.pincodeLocality,
            Customer_Perm_StateCode:quickValues?.kycDetails?.stateCd,
            Customer_PermState:quickValues?.kycDetails?.TXT_STATE,
            Customer_Pehchaan_id: quickValues.Customer_Pehchaan_id,
            PolicyStartDate: currDate, //quickValues.start_date,
            ProposalDate: currDate, //quickValues.proposal_date,
          };
          break;
        default:
      }
    }
  });

  return initialValues;
};

export const reInitialiseHdfcOptimaRestoreInitialValues = (
  initialValues,
  quickValues
) => {
  console.log('isni', initialValues.primaryDetail, quickValues)
  let gender = quickValues.gender;

  Object.entries(initialValues).forEach((tab, tabInd) => {
    if (Array.isArray(tab[1])) {
      switch (tab[0]) {
        case "primaryDetail":
          tab[1].forEach((primaryObj, ind) => {
            
            initialValues["primaryDetail"][`${ind}`] = {
              ...initialValues["primaryDetail"][`${ind}`],
              name: quickValues?.insureds?.[ind]?.name,
              age: quickValues?.insureds?.[ind]?.age,
              sa: quickValues?.sumInsuredValue,  
              dob:  quickValues?.insureds?.[ind]?.relationship === "Self" ? quickValues?.kycDetails?.dateOfBirth: null,
            };
            // initialValues["primaryDetail"][`${ind}`].addOnsList[0]["hdcCheck"] = "false";
            // initialValues["primaryDetail"][`${ind}`].addOnsList[0]["ipaRiderCheck"] = "false";
            // initialValues["primaryDetail"][`${ind}`].addOnsList[0]["pCheck"] = "false";
            // initialValues["primaryDetail"][`${ind}`].addOnsList[0]["unlimitedRiderCheck"] = "false";
            // initialValues["primaryDetail"][`${ind}`].addOnsList[0]["ipaSa"] = "0";
            // initialValues["primaryDetail"][`${ind}`].addOnsList[0]["hdcSa"] = "0";
            // initialValues["primaryDetail"][0]["gender"] = gender === "Male" ? "M" : "F";

          });
          break;
        case "medicalQuestions":
          tab[1].forEach((primaryObj, ind) => {
            initialValues["medicalQuestions"][`${ind}`] = {
              ...initialValues["medicalQuestions"][`${ind}`],
              name: quickValues?.insureds?.[ind]?.name,
              dob:
              quickValues?.insureds?.[ind]?.relationship === "Self"
                ? quickValues?.kycDetails?.dateOfBirth
                : null,
            };
          });
          break;
        default:
      }
    } else {
      switch (tab[0]) {
        case "dependentDetail":
        // Calculating age
        let dob = new Date(quickValues?.kycDetails?.dateOfBirth).getTime();
        let diff = Date.now() - dob;
        let ageInDate = new Date(diff);
        let ageInYear = Math.abs(ageInDate.getUTCFullYear() - 1970);

          initialValues["dependentDetail"] = {
            ...initialValues["dependentDetail"],
            name: (quickValues?.kycDetails?.firstName? `${quickValues?.kycDetails?.firstName} `:'')+ (quickValues?.kycDetails?.middleName? `${quickValues?.kycDetails?.middleName} `:'') + (quickValues?.kycDetails?.lastName??""),
            dob: quickValues?.kycDetails?.dateOfBirth ?? "",
            age: ageInYear,
            contact: quickValues?.mobile_no,
            email: quickValues?.email_id,
            Permanent_Address1: quickValues?.kycDetails?.permanentAddress1,
            Permanent_Address2: quickValues?.kycDetails?.permanentAddress2,
            zipcode: quickValues?.postalCode,
            city: quickValues?.kycDetails?.cityDistCd,
            cityName: quickValues?.kycDetails?.TXT_CITYDISTRICT,
            districtCode: quickValues?.kycDetails?.cityDistCd,
            district: quickValues?.kycDetails?.TXT_CITYDISTRICT,
            state: quickValues?.kycDetails?.TXT_STATE,
            Pehchaan_id: quickValues?.Customer_Pehchaan_id,
          };
          initialValues["dependentDetail"].addOnsList[0]["ipaSa"] = "0";
          initialValues["dependentDetail"].addOnsList[0]["hdcSa"] = "0";
          break;
        default:
      }
    }
  });

  return initialValues;
};
